import request from '@/utils/request'

//创建孩子
export function createUserChild(data) {
  return request({
    url: '/admin/child/createUserChild',
    method: 'post',
    data: data
  })
}

export function qlUserChild(data) {
  return request({
    url: '/admin/child/qlUserChild',
    method: 'post',
    data: data
  })
}

//修改孩子信息
export function updateChildInfo(data) {
  return request({
    url: '/admin/child/updateChildInfo',
    method: 'post',
    data: data
  })
}
export function selectChild(params) {
  return request({
    url: '/admin/child/selectChild',
    method: 'get',
    params: params
  })
}

/**
 * 修改孩子等级
 * @param params
 */
export function changeChildLevel(data) {
  return request({
    url: '/admin/child/changeChildLevel',
    method: 'post',
    data: data
  })
}

/**
 *
 * @param params
 */
export function findByPhoneNumber(params) {
  return request({
    url: '/admin/child/findByPhoneNumber',
    method: 'get',
    params: params
  })
}
/**
 *
 * @param params
 */
export function findVipStatisticsData(params) {
  return request({
    url: '/admin/child/findVipStatisticsData',
    method: 'get',
    params: params
  })
}

/**
 *
 * @param params
 */
export function findVipUserStatisticsData(params) {
  return request({
    url: '/admin/child/findVipUserStatisticsData',
    method: 'get',
    params: params
  })
}

//查询介绍人购卡的会员
export function introduceUserList(data) {
  return request({
    url: '/admin/child/introduceUserList',
    method: 'post',
    data: data
  })
}

//查询介绍的会员的信息
export function introduceUserListByPhone(data) {
  return request({
    url: '/admin/child/introduceUserListByPhone',
    method: 'post',
    data: data
  })
}

//查询公共池的用户
export function publicPoolList(data) {
  return request({
    url: '/admin/child/publicPoolList',
    method: 'post',
    data: data
  })
}




// WEBPACK FOOTER //
// ./src/api/userChild.js